module.exports = __webpack_public_path__ + "static/travelzik4-d4cc8937615d4f4e6cc4b3016df66dfa.png";